import { Button, Container } from "react-bootstrap";

export default function JoyBlog() {
    return(<Container>
        <h1 style={{textAlign:"center", fontSize:"40px", marginTop:"200px"}}>Great Things Coming Soon!</h1>
        <p style={{textAlign:"center"}}>Meanwhile, feel free to explore our website or our youtube channel</p>
        <div style={{textAlign:"center", marginBottom:"200px"}}>
            <Button href={`${process.env.PUBLIC_URL}/colearning/overview`} variant="outline-primary">Courses <i className="bi bi-arrow-right"></i></Button>&nbsp;&nbsp;&nbsp;&nbsp;
            <Button href="https://www.youtube.com/channel/UC57YSsFi7QyDwF1LapO-pTQ" target="_blank">YT Channel <i className="bi bi-box-arrow-up-right"></i></Button>
        </div>        
    </Container>
    )
}